"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalError_styled_exports = {};
__export(GlobalError_styled_exports, {
  StyledEmptyStateContainer: () => StyledEmptyStateContainer,
  StyledErrorCodeText: () => StyledErrorCodeText,
  StyledGoBackButton: () => StyledGoBackButton,
  StyledImageBox: () => StyledImageBox,
  StyledOptionalText: () => StyledOptionalText
});
module.exports = __toCommonJS(GlobalError_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Heading = require("../../atoms/Heading/Heading.component");
var import_Button = require("../../atoms/Button/Button.component");
var StyledEmptyStateContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalErrorstyled__StyledEmptyStateContainer",
  componentId: "sc-1rgpsjp-0"
})(function() {
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;align-items:center;box-sizing:border-box;"]);
});
var StyledImageBox = import_styled_components.default.img.withConfig({
  displayName: "GlobalErrorstyled__StyledImageBox",
  componentId: "sc-1rgpsjp-1"
})(function() {
  return (0, import_styled_components.css)(["margin-top:312px;height:73px;width:107px;padding-left:0;"]);
});
var StyledErrorCodeText = (0, import_styled_components.default)(import_Heading.Heading).withConfig({
  displayName: "GlobalErrorstyled__StyledErrorCodeText",
  componentId: "sc-1rgpsjp-2"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["margin-top:24px;color:", ";font-weight:", ";font-size:", ";text-align:center;"], theme.colors.black, theme.typography.weights.black, theme.typography.sizes.medium);
});
var StyledOptionalText = (0, import_styled_components.default)(import_Heading.Heading).withConfig({
  displayName: "GlobalErrorstyled__StyledOptionalText",
  componentId: "sc-1rgpsjp-3"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["color:", ";text-align:center;font-size:", ";"], theme.colors.beige[180], theme.typography.sizes.medium);
});
var StyledGoBackButton = (0, import_styled_components.default)(import_Button.Button).withConfig({
  displayName: "GlobalErrorstyled__StyledGoBackButton",
  componentId: "sc-1rgpsjp-4"
})(function() {
  return (0, import_styled_components.css)(["height:40px;margin-top:16px;"]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledEmptyStateContainer,
  StyledErrorCodeText,
  StyledGoBackButton,
  StyledImageBox,
  StyledOptionalText
});
//# sourceMappingURL=GlobalError.styled.js.map